// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--un3EU","courses":"styles-module--courses--3f0oY","course":"styles-module--course--1Pnzi"};